import React from 'react';

import {
  AccordionItem,
} from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField } from '../../../components';

import './style.scss';

// Notice: This paragraph is deprecated. We now use the FAQ paragraph.
// But this paragraph has been updated to support the new styling.
const ParagraphFaqItem = ({ entity }) => {
  const title = entity.getIn(['field_question', 0, 'processed'], '');
  const body = entity.getIn(['field_answer', 0, 'processed'], '');

  const renderTitle = () => {
    return (
      <WysiwygField
        property="schema:text"
        className="Text__title"
        html={title}
      />
    );
  };

  const renderItemContent = () => {
    return (
      <div className="FAQAccordionItem__content">
        <div className="col-12 col-lg-9 FAQAccordionItem__content__inner">
          <WysiwygField
            property="schema:text"
            className="Text__body"
            html={body}
          />
        </div>
      </div>
    );
  };

  return (
    <AccordionItem
      className="FAQAccordionItem"
      title={renderTitle()}
      content={renderItemContent()}
      titleComponent={({ className, children }) => {
        return (<h3 className={className}>{children}<i className="icon icon-caret" /></h3>);
      }}
    />
  );
};

export default ParagraphFaqItem;
